module.exports = __webpack_public_path__ + "static/sun_shine-1e48132971309e1953858c8e24527208.png";